// Footer Vue instance moved to main.js to avoid duplicate instances
// The openList method and footer data are now in main.js

/*
new Vue({
    delimiters: ['[[', ']]'],
    el: '#footer',
    data: {
        footer: {
            facebook: true,
            instagram: true,
            whatsapp: true,
            youtube: true,
            ssl: true,
            google: true,
            visa: true,
            diners: true,
            amex: true,
            mastercard: true,
            aura: true,
            hipercard: true,
            elo: true,
            shoppub: true,
        }
    },
    methods: {
        openList(event) {
            event.target.classList.toggle('active');
            event.target.nextElementSibling.classList.toggle('active');
        }
    }
})
*/